module.exports = __webpack_public_path__ + "static/img/activity02.0992c3e9.png";